import { API_URL } from "../constants/configs"

export const createApplicant = async (data: FormData) => {
  return await fetch(API_URL + "/api/applicants", {
    method: "post",
    mode: "cors",
    body: data,
  })
}
